import React from 'react'
import "./pricing/styles.scss";

const FooterCTACard = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="ctawraper mt-4 mt-xl-5">
            Stay in control of your finances with Toola.
            <div className="ctabtn">
              Send a message
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterCTACard;